import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of, Subscription } from 'rxjs';

import { mergeMap } from 'rxjs/operators';
import { PropBoOption } from '../../../../bodisplay';
import { CustomgridComponent, CustomGridService } from '../../../../customgrid';
import { BObjectModel, BoModel, QResult, QueovalDik, TableDefaultValue } from '../../../../models';
import { CoreService, HttpService } from '../../../../services';
import { StageService } from '../services/stage-modal.service';

@Component({
  selector: 'q-comp-depenses',
  templateUrl: './depenses.component.html',
  styleUrls: ['./depenses.component.css'],
})
export class DepensesComponent implements OnInit, OnDestroy {

  constructor(
    private modalService: NgbModal,
    private http: HttpService,
    private indParam: CoreService,
    public service: StageService,
    protected customgridservice: CustomGridService,
  ) { }

  @ViewChild('modalBo') modalBo: ElementRef;
  @ViewChild('modal') modal: ElementRef;
  @ViewChild('modalDeleteValidation') modalDeleteValidation: ElementRef;

  depensesType: Array<Depense>;
  adminDepenseType: boolean = false;
  selectedRow: Array<Depense> = new Array<Depense>();
  deleteDisable: boolean = true;
  gridReload: boolean = true;
  /* bo à afficher dans la grid */
  public boModel: BObjectModel;
  /* modal ou ouvrir le bo*/


  @ViewChild('grid') grid: CustomgridComponent;

  propOption: PropBoOption;

  ngOnInit(): void {
    this.getDepenseType().subscribe(depenses => this.depensesType = depenses);
    this.http.getHttp<QResult<Array<QueovalDik>>>(`${this.indParam.AppParams.apiUrl}api/Depense/Prop`).subscribe((result: QResult<Array<QueovalDik>>) => {
      let idBo: string = '';
      let idProp: string = '';
      result.Value.forEach(x => {
        switch (x.key) {
          case 'idBo': idBo = x.value;
          case 'idProp': idProp = x.value;
        }
      });
      this.propOption = new PropBoOption(idBo, new BoModel(), idProp, '', '', '', 'AUTO',);
    });

    this.InitGrid();
  }

  getDepenseType(): Observable<Array<Depense>> {
    return this.http.getHttp<QResult<Array<TableDefaultValue>>>(`${this.indParam.AppParams.apiUrl}api/Depense/Type`).pipe(
      mergeMap((result: QResult<Array<TableDefaultValue>>) => {
        return of(result.Value.map(x => new Depense(x.Ident.toString(), x.Info_BOV, x.VastrBOV)));
      })
    )
  }

  openDepenseTypeAdministration(open: boolean | null) {
    this.adminDepenseType = open!=null ? open : !this.adminDepenseType;
    if (!open) {
      this.getDepenseType().subscribe(depenses => this.depensesType = depenses);
    }
  }

  openModalDepenses(): void {
    this.modalService.open(this.modal, { size: 'q-xxl', centered: true, scrollable: true, windowClass: 'qmodalover' }).result.then((result) => { },
      (reason) => {
        this.openDepenseTypeAdministration(false);
        this.reloadGrid();
      });
  }

  openModalDelete(): void {
    this.modalService.open(this.modalDeleteValidation, { centered: true, scrollable: true, windowClass: 'qmodalover' })
  }


  createDepenses(): void {
    let selectedDepenses = this.depensesType.filter(d => d.IsSelected);
    selectedDepenses.forEach(x => x.IsSelected = false);
    this.http.postHttp<QResult<Array<string>>>(`${this.indParam.AppParams.apiUrl}api/Stage/${this.service.Stage.Ident}/Depenses/CREATE`, selectedDepenses).subscribe((result: QResult<Array<string>>) => {
      this.modalService.dismissAll();
    })
  }

  cellValueChanged(e: any) {
    const colName = e.colDef.field;
    const value = e.source ? e.source : e.value;
    const ident = e.node.data.Ident;
    //console.log(' ident:' + ident + ' colName:' + colName + ' value:' + value);

    const data: Array<QueovalDik> = Array<QueovalDik>();
    data.push(new QueovalDik(colName, value));

    this.http.patchHttp<QResult<string>>(`${this.indParam.AppParams.apiUrl}api/Stage/${this.service.Stage.Ident}/Depenses/${ident}`, data).subscribe((result: QResult<string>) => {
      this.indParam
    });
  };

  selectChanged(e: any) {
    this.selectedRow = e.api.getSelectedNodes().map((node: any) => new Depense(node.data.Ident, node.data.Type_DEP, node.data.ObjetDEP));
    this.deleteDisable = this.selectedRow.length > 0;
  }

  deleteSelectedValue() {
    this.http.postHttp(`${this.indParam.AppParams.apiUrl}api/Stage/${this.service.Stage.Ident}/Depenses/DELETE`, this.selectedRow).subscribe(() => {
      this.reloadGrid();
    })
  }

  reloadGrid() {
    this.gridReload = false;
    setTimeout(() => this.gridReload = true, 0);
  }


  public gridObserver: Subscription;
  private InitGrid(): void {
    this.gridObserver = this.customgridservice.getItem('PageDepenseAg').subscribe((res: BObjectModel) => {
      switch (res.Action) {
        case 'ANG_PAGE':
          if (res.IdDonneeFils && res.IdDonneeFils != '0') {
            this.boModel = res;
            this.boModel.ShowSaveButton = true;
            this.modalService.open(this.modalBo, { size: 'q-xxl', centered: true, windowClass: 'qmodalover modal-bo' }).result.then((modalResult) => {
            });
          }
          break;
      }
    });
  }

  ngOnDestroy(): void {
    this.gridObserver.unsubscribe();
  }

}


export class Depense extends TableDefaultValue {
  commentaire: string;
  montant: number;

  constructor(ident: string, info_BOV: string, vastrBOV: string) {
    super();
    this.Ident = +ident;
    this.Info_BOV = info_BOV;
    this.VastrBOV = vastrBOV;
  }
}
